<template>
    <div class="my-root">
        <main class="main">
            <!--            <span class="key">哔哩哔哩:</span>-->
            <!--            <span class="bold" @click="copy('FFFFQQQQ')">FFFFQQQQ</span>-->
            <!--            <span class="bold" @click="copy('https://space.bilibili.com/15599091')">https://space.bilibili.com/15599091</span>-->
            <span class="key br">邮箱:</span>
            <span class="bold" @click="copy('fzzphotographs@qq.com')">fzzphotographs@qq.com</span>
            <span class="key br">点击上方内容可以直接复制</span>

        </main>
        <div class="bottom">
            <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2024110351号-1</a>
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37010302001562" rel="noreferrer"
               target="_blank"><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAFQklEQVRYw+3Wa1BUdRjH8SOpMeg4WhZGpDIxiaaTeUFgWrxE4AVRQJGlRRAVIV1JkbgMgQLi5AVBQSVLSp0xlEAUKBEEFZCrCstll8UV2AV2YbmoGCrYv31+R95UL5pmmtamZ+bz6rz5nvOc/5zDcX9jGLs/iTxuyvIlWYkRFeTHA2HVRFtzfhthTG5KuH96/vUgNlC4mMgyw1NJit/aAXLKazYje9xtIMZ/OZz50gW+9hcNkvoLEemEPbnrSP47QYwxQ5Ifv54RqzcXwFFvSyjaOhfavN8F7Y5ZcC/HH9JOB4LNa9Zw5YA76OZV8vIGMdZtSp7cDrtOnOavYiQhTAiPwi1AMtIQaqyngsxpBtw2GAGDKfaQmpUAa6xc4Vfp4UtEdzAMycsT9JQ1Tyctl/2eEkuTlYysF/rCUNxMqDEzgTqzSXBnpgnIHCzgjvEEuD52DLBr3rA1MAaWmNtB582wdtIljZ9G9D+IPU6aTxIPBjHCcXvg3CEh9K2fDLWvjIH6D6fwTIyheuwEqLUyhzLOALq8pkN+bgRw3HY4FBsMzxojZxP9DequLjAlQwVrbpIjhyIY4UYGQ/buhdBqPxlk3Gion2IMDQIz3kJe/ZS34I7uHkmD7VSQVgYDNyIAwsNCgfXGXoOBPjP9DKrOCAogA2etGTmTHAMcFwFZye7wS5QlVHGjoEw4A2qPCUBZ6AzNcQ5Q/YYRdO+YB1U3dsDwypLio4FJ3ECryIzWz6Cm3NgTRHN8HiPF6eHAGSbAdh8feFZkB7krzaHE9h2o85sDsiAbkIsXQMN+e2CtGyF0kzdwXCgU5++D/ouLQFV4OEU/g2Q/iNuIPNaKkQflAWBqexxGjhLDVUcL6IwSQN3SGVChe6FJg9dckCx6D1QBliDZLIAxo7eA8eyv4KE0BJqTrHkZvnL9DJKn+Twmt0NsGGHZy2Dn3kQYfsQ53Hh4/r4RNGz8AIpdzKEuaAF0RC2E57MmQgE3ATjuM/CPiANW7AqSfQJQ5vk362eQKmd3JrmXsoSRocpNIMnbB9zbceDIWUPmuHFQNMkISqa9DpUvNK6YDpW2s8DfwBK48WFQnhMCgzUBoLy0BrRVe5P0NWjPLdKUsJiR1tR1wGp8IeZwMgx/SrgRvjxuAziNcwLvyathLOcJHLflhRDYGRYFrNET2rJ5yvPLoas0tOj/oL8UpC4JHyTSU+6MNCS4gvKoAB5WiKG+MAQSg0WwLXQ/ZJ3xhao0FxB5hYCbUwAEfhEF3Td8QP2dAOQnPwFlxgrolUVq9TPoaX+ZB2nLc2Gk6awj1MU78HZZwJMid2Byb550JQwVO0NfxlJgdz14vWKeRAiK6DlQF28PLZdcoLNcBIO92bb6GTQ8Q/13RURT6tlH2gvXMlITLYD6uI+gp2ozdF0VQXumM6ivCqGvahM8kPiDItkeGo8tB025GFQ3xFrSr06zI3/4yde7oN7m0sWk5eKWDqK5JWJQvAHac9ygq3Adr9gTNNc3QG85rzPfHe5/7wDtPwuhp/Zz6CjyhaZzwi6ivfetHdH/oP77+3PJQOsuRnqkQdCa4wWqyx6gyecpL64GTaEX7ycXUJz4GJp1B4O0X/Hg0Xp1tFV+8Ei1k6c5coHofxBrrzQinbKYo0SVJ+wn6iurGHlY5gY911aDJnMFaHXXiDp9GQyvtKfUA9QFTtBZ7gPdit0tpFd9OpwwFmlA9D/o9yNLDpxIKmI8PMnNSNtviCLVpYTITzrXEGWaq4qos0WgOPdpCenIF+eRrurjB4k0PXopYZG6gMg/D/gNBUxhAbSAmKMAAAAASUVORK5CYII="
                alt=""/>鲁公网安备37010302001562</a>
        </div>
    </div>
</template>
<script>
export default {
    name: "my",
    methods: {
        copy(text) {
            try {
                const t = document.createElement('textarea')
                t.nodeValue = text
                t.value = text
                document.body.appendChild(t)
                t.select()
                document.execCommand('copy');
                document.body.removeChild(t)
                console.log('Text copied to clipboard');
                this.$message.success('复制成功')
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        }
    }
}
</script>
<style scoped lang="less">
.bottom {
    width: 100%;
    height: 40px;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    a {
        margin-right: 10px;
        color: #8c939d;
        text-decoration: none;
        outline: none;
        font-size: 12px;

        display: flex;
        align-items: center;
        justify-content: left;

        img {
            width: 14px;
            margin-right: 2px;
            object-fit: contain;
        }
    }
}

.my-root {
    width: 100%;
    height: 100vh;
    display: flex;

    main {
        margin: auto;
    }

    span.key {
        padding-right: 6px;
    }

    span.bold {
        cursor: copy;
        line-height: 2em;
        font-weight: bold;
        padding: 4px;
        border-radius: 5px;

        &:hover {
            text-shadow: 0 0 5px rgba(122, 122, 122, .7);
        }
    }

    span.br::before {
        content: "\A";
        white-space: pre;
    }

    span.bold + span.bold::before {
        content: ", ";
        font-weight: 500;
        //margin-left: -.25em;
    }
}
</style>
